// extracted by mini-css-extract-plugin
export default {"modal":"modalPaymentServizioStyle_modal__sgbee"};